<template comments>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("nav.clients") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <h5 class="mb-0">On Call Central</h5>

            <p>
              <a href="https://www.oncallcentral.com/" target="_blank" rel="nofollow"
                >www.oncallcentral.com</a
              >
            </p>

            <p>
              {{ $t("clients.oncallcentral_description") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-2">
          <div class="im-block">
            <h5 class="mb-0">Property Portfolio Software</h5>

            <p>
              <a href="https://www.propertyportfoliosoftware.co.uk/" target="_blank" rel="nofollow"
                >www.propertyportfoliosoftware.co.uk</a
              >
            </p>

            <p>
              {{ $t("clients.pps_description") }}
            </p>
          </div>

          <div class="im-block">
            <h5 class="mb-0">Tax Insider</h5>

            <p>
              <a href="https://www.taxinsider.co.uk/" target="_blank" rel="nofollow"
                >www.taxinsider.co.uk</a
              >
            </p>

            <p>
              {{ $t("clients.taxinsider_description") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-xl-4">
        <div class="im-col im-col-3">
          <div class="im-block">
            <h5 class="mb-0">Globe Law and Business</h5>

            <p>
              <a href="https://www.globelawandbusiness.com/" target="_blank" rel="nofollow"
                >www.globelawandbusiness.com</a
              >
            </p>

            <p>
              {{ $t("clients.globelaw_description") }}
            </p>
          </div>

          <div class="im-block">
            <h5 class="mb-0">Рентген Русе</h5>

            <p>
              <a href="https://www.rentgen-ruse.com/" target="_blank">www.rentgen-ruse.com</a>
            </p>

            <p>
              {{ $t("clients.rentgen_description") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ClientsSection",
  };
</script>
